import UIStrings from '@/Utils/UIStrings';

function listConsistencyTest(sourceText: string, patternWitthBulletPoint: string, bulletPoint: string): boolean {
    return (
        sourceText.split(patternWitthBulletPoint).length - 1 ===
        sourceText.split('').filter((x) => x === bulletPoint).length
    );
}

function formatBuletPoints(sourceText: string) {
    // its quite trivial to differentiate between a '-' used as a bullet point and a totally normal sentence hyphen, not formatting '-' yet for now
    const bulletPointToFormat = '•';

    if (!sourceText.includes(bulletPointToFormat)) {
        return sourceText;
    }

    const idealPattern = `<li>`;

    // check if the current text already has list tags
    if (sourceText.includes(idealPattern)) {
        return sourceText;
    }

    // check against the following patterns and attempt to replace accordingly
    const patterns = [
        `\n${bulletPointToFormat}\t`,
        `\n${bulletPointToFormat} `,
        ` ${bulletPointToFormat} `,
        `${bulletPointToFormat} `,
        `${bulletPointToFormat}\t`,
        `\n${bulletPointToFormat}`,
        bulletPointToFormat,
    ];

    let result = sourceText;

    for (let i = 0; i < patterns.length; i++) {
        const pattern = patterns[i];

        if (sourceText.includes(pattern)) {
            if (listConsistencyTest(sourceText, pattern, bulletPointToFormat)) {
                result = `<ul>${sourceText.replaceAll(pattern, idealPattern)}</ul>`;
                break;
            }
        }
    }

    return result.trim();
}

function formatTruncatedSummary(sourceText: string) {
    if (sourceText.endsWith('…')) {
        return `${sourceText}${UIStrings.TruncatedProfileSummaryInfo}`;
    }

    return sourceText;
}

export default function formatSummary(sourceText: string) {
    const truncatedSummary = formatTruncatedSummary(sourceText);

    return formatBuletPoints(truncatedSummary);
}
